import Person from "@/domains/-person/models/Person.ts";
import {AbstractWorkspacePerson} from "@/domains/-workspace/models/AbstractWorkspacePerson.ts";
import {PersonAlias} from "@/domains/-workspace/models/PersonAlias.ts";
import {Workspace} from "@/domains/-workspace/models/Workspace.ts";
import {Email, GetWorkspaceCoachee, Lang, PatchWorkspaceCoachee, PersonId} from "@/sdk.ts";

export class WorkspacePerson extends AbstractWorkspacePerson {
  readonly person: Person;
  readonly alias: PersonAlias;

  constructor(workspace: Workspace, props: GetWorkspaceCoachee.Result) {
    super(workspace, props.person_roles);
    this.person = new Person(props);
    this.alias = new PersonAlias(props.person_alias);
  }

  update(props: PatchWorkspaceCoachee.Result): void {
    if(props.email) this.person.email = props.email;
    if(props.person_alias) this.alias.update(props.person_alias);
    super.update(props);
  }

  get public_id(): PersonId {
    return this.person.public_id;
  }

  get email(): Email {
    return this.person.email;
  }

  get lang(): undefined | Lang {
    return this.person.lang;
  }

  get is_verified(): boolean {
    return this.person.is_verified;
  }

  get first_name(): string {
    return this.alias.first_name;
  }

  get last_name(): string {
    return this.alias.last_name;
  }

  get full_name(): string {
    return this.first_name + ' ' + this.last_name
  }
}